export const logoutUser = (reason = "SESSION_EXPIRED") => {
    localStorage.setItem("FORCE_LOGOUT", "true");
    localStorage.setItem("LOGOUT_REASON", reason);

    window.dispatchEvent(new Event("FORCE_LOGOUT_EVENT"));
};

export const clearForceLogout = () => {
    localStorage.removeItem("FORCE_LOGOUT");
    localStorage.removeItem("LOGOUT_REASON");
};

